import dayjs from 'dayjs';

export const chechIfLastRouteLegIsAlreadyStarted = (group) => {
  const lastPartOfTheRouteTime = dayjs(group?.info_marketplace?.ida_ultimo_trecho);
  return dayjs().isAfter(lastPartOfTheRouteTime);
};
